import React from 'react'
import { RouteConstants } from '../../setup/routeConstants'
import LazyProtectedRoute from '../LazyProtectedRoute'
import { ACCESS_LISTING_USER_PERMISSIONS_TAB } from '../../auth/policies'
import OverviewTab from '../../components/Listings/Listing/Tabs/Overview'
import SettingsTab from '../../components/Listings/Listing/Tabs/Settings'
import DeployTab from '../../components/Listings/Listing/Tabs/Deploy'
import ReportsTab from '../../components/Listings/Listing/Tabs/Reports'
import UserPermissionsTab from '../../components/Partners/Listing/Tabs/Settings/Permissions/UserPermissions'

const VerificationListingPageComponent = React.lazy(() => import('../../components/Listings/Listing'))

export default {
	path: RouteConstants.verification.listing.path,
	element: (
		<LazyProtectedRoute
			requiredPolicies={[]}
			component={<VerificationListingPageComponent />} 
		/>
	),
	children: [
		{
			index: true,
			element: <LazyProtectedRoute component={<OverviewTab />} requiredPolicies={[]} />,
		},
		{
			path: 'overview',
			element: <LazyProtectedRoute component={<OverviewTab />} requiredPolicies={[]} />,
		},
		{
			path: 'settings',
			element: <LazyProtectedRoute component={<SettingsTab />} requiredPolicies={[]} />,
		},
		{
			path: 'deploy',
			element: <LazyProtectedRoute component={<DeployTab />} requiredPolicies={[]} />,
		},
		{
			path: 'user-permissions',
			element: <LazyProtectedRoute component={<UserPermissionsTab />} requiredPolicies={[ACCESS_LISTING_USER_PERMISSIONS_TAB]} />,
		},
		{
			path: 'reports',
			element: <LazyProtectedRoute component={<ReportsTab />} requiredPolicies={[]} />,
		},
	],
}